/**
 * Native footer disclosures: expanded on desktop, collapsed initially on mobile.
 * Keep one media listener per connected section, even when the editor moves it.
 * User toggles remain native; no cloned menus, polling or animation dependencies.
 */
(() => {
  'use strict';
  if (customElements.get('etr-footer')) return;

  customElements.define('etr-footer', class extends HTMLElement {
    /** Initialise responsive defaults once for this connection. */
    connectedCallback() {
      if (this.media) return;
      this.media = window.matchMedia('(min-width: 750px)');
      this.update = () => {
        this.querySelectorAll('details').forEach((menu) => {
          menu.open = this.media.matches;
        });
      };
      this.update();
      this.media.addEventListener('change', this.update);
    }

    /** Release the old listener before a section is removed or reconnected. */
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.update);
      this.media = null;
      this.update = null;
    }
  });
})();
